var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-center be-user"},[_c('base-avatar',{attrs:{"avatar":_vm.user.avatar || _vm.user.name,"isName":!_vm.user.avatar}}),_c('div',{staticClass:"be-user-name flex-item"},[_vm._v(" "+_vm._s(_vm.fullname())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }